<div mat-dialog-title>
  <div class="d-flex justify-content-between">
    Document Cart
    <i class="fa fa-times-circle pull-right" aria-hidden="true" (click)="closeDialog($event)"></i>
  </div>
</div>

<div mat-dialog-content class="m-0">
  <div class="row reset-row  eip-pt-10">
    <div class="col-xl-4 col-lg-4 col-md-6 col-sm-12 tab-container">
      <mat-label class="qr-label">Document Type</mat-label>
      <mat-button-toggle-group aria-label="Document" class="com-semiauto" [value]='docType'
        (change)="tabClick($event.value)">
        <mat-button-toggle value="Repository" aria-checked="true">Repository</mat-button-toggle>
        <mat-button-toggle value="Workflow">Workflow</mat-button-toggle>
      </mat-button-toggle-group>
    </div>
    <div class="col-xl-4 col-lg-4 col-md-4 col-sm-6 col-xs-12">
      <EIPAutoComplete ShowTextValueField='N' WaterMarkText="Created By" class="business-group" TextField="description"
        ValueField="value" [dataSource]='createdByList' setId="ddCreatedById" (valueChange)='changeCreatedBy($event)'
        [IsCascading]='true'>
      </EIPAutoComplete>
    </div>
    <div class="col-xl-4 col-lg-4 col-md-6 col-sm-6 col-xs-12">
      <EIPAutoComplete ShowTextValueField='N' WaterMarkText="Authorised By" class="business-group"
        TextField="description" ValueField="value" [dataSource]='authorizedByList' setId="ddAuthorisedById"
        (valueChange)='changeAuthorizedBy($event)' [IsCascading]='true'>
      </EIPAutoComplete>
    </div>
  </div>
  <div class="eip-pl-20 eip-pr-20 eip-pb-20">
    <EIPGeneralCart [CartParameters]="cartRequest" (OnCartSubmit)='getSelectedCartItems($event)'
      (OnClick)='setCartParams()'>
    </EIPGeneralCart>
  </div>
</div>